import { Content } from '@amzn/awscat-pattern-library-service-model';
import _ from 'lodash';

/**
 * Returns true when two {@link Content} values are equal by their JSON-shaped
 * data, ignoring class identity.
 *
 * Workaround: the API delivers content as `Content` class instances, but
 * Tiptap round-trips the same data as plain JSON. `_.isEqual` checks
 * constructors and reports these as different even when field values match.
 *
 * Not safe for values containing `Date`, `Map`, `Set`, `BigInt`, functions,
 * or circular references.
 */
export function isContentValueEqual(contentA: unknown, contentB: unknown): boolean {
  return _.isEqual(toJsonShape(contentA), toJsonShape(contentB));
}

// `JSON.stringify(undefined)` returns `undefined` (not the string "undefined"),
// which then makes `JSON.parse` throw. Guard so callers can pass undefined
// freely.
function toJsonShape(v: unknown): unknown {
  return v === undefined ? undefined : JSON.parse(JSON.stringify(v));
}
